export default __webpack_public_path__ + "static/media/gear.9126f7e1.svg";